<nav class="horizontal-menu">
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.stockManager()">
		<mat-icon>bar_chart</mat-icon>
		{{ 'admin_console.stock_management' | translate }}
	</a>
	<!-- <a mat-raised-button>
		<mat-icon>settings</mat-icon>
		{{ 'admin_console.machine' | translate }}
	</a> -->
	<a mat-raised-button (click)="openDialog()">
		<mat-icon>print</mat-icon>
		{{ 'admin_console.printer_settings' | translate }}
	</a>
	<!-- <a mat-raised-button [routerLink]="'/' + urlLinkEnum.openingHours()">
		<mat-icon>access_time</mat-icon>
		{{ 'admin_console.opening_hours' | translate }}
	</a> -->
	<!-- <a mat-raised-button (click)="openDialog()">
		<mat-icon>settings</mat-icon>
		Printer Settings
	</a> -->
	<!--	<ng-container *ngIf="venueValue$ | async as venueData">-->
	<!--		<ng-container *ngIf="venueData?.deliveryProviders?.uberDirect?.customerId">-->
	<!--			<a-->
	<!--				mat-raised-button-->
	<!--				[disabled]="disableButtonUberDirect"-->
	<!--				class="button-delivery last-btn"-->
	<!--				(click)="switchLogicUberDirect(venueData)"-->
	<!--			>-->
	<!--				<div>-->
	<!--					<h3 class="title-text">Uber Direct Status</h3>-->

	<!--					@if (venueData.deliveryProviders?.uberDirect?.enabled) {-->
	<!--					<h3 class="green">{{ 'common.online' | translate }}</h3>-->
	<!--					} @else {-->
	<!--					<h3 class="red">{{ 'common.offline' | translate }}</h3>-->
	<!--					}-->
	<!--				</div>-->
	<!--			</a>-->
	<!--		</ng-container>-->
	<!--	</ng-container>-->

	<a mat-raised-button (click)="logout()" class="out-color">
		<mat-icon>logout</mat-icon>
		{{ 'common.logout' | translate }}
	</a>
</nav>
